import React from 'react';
import {useAuth} from "../../../../utils/hooks/useAuth";
import ProfilePhoto from "../../../ProfilePhoto/ProfilePhoto";
import {ProfilePhotoSizeE} from "../../../../models/enums";
import { useNavigate } from 'react-router-dom';
import { RoutesE } from '../../../../routes/routesData';

import styles from './sidebarProfile.module.scss';

/**
 * Shows logged user profile data
 * */

const SidebarProfile = () => {
    const {currentUser} = useAuth();
    const navigate = useNavigate();

    const navigateToProfileSettings = () => {
        navigate(RoutesE.SETTINGS_USER);
    };

    return (
        <div className={styles.wrapper} onClick={navigateToProfileSettings}>
            <ProfilePhoto size={ProfilePhotoSizeE.LARGE}/>
            <p className={styles.userName}>
                {currentUser?.userName}
            </p>
            <p className={styles.email}>
                {currentUser?.email}
            </p>
        </div>
    );
};

export default SidebarProfile;